module.exports = __webpack_public_path__ + "static/img/ZRS2761_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ZRS2761_1.png
// module id = HCia
// module chunks = 0